import { IPopupModal, PopupConfig } from '../popup-modal.class';
import { Component, Input, Output, EventEmitter, ApplicationRef, ElementRef, ViewChild } from '@angular/core';
declare var $: any;
@Component({
    selector: 'ntb-info-popup',
    template: require('./info-modal.component.html'),
    styles: [require('./info-modal.component.css')],

})
export class InfoModalComponent implements IPopupModal{
    @Input() messageObj: PopupConfig;
    @Output() hideEvent: EventEmitter<string> = new EventEmitter<string>()
     @ViewChild('rootEle') rootRef: ElementRef;

    show(){
        $(this.rootRef.nativeElement).modal('show');
    }

    hide(){
        $(this.rootRef.nativeElement).modal('hide');
        this.hideEvent.emit('closed')
    }

    setPopupObject(obj){
        this.messageObj = this.messageObj || obj;

    }
    constructor(private appRef: ApplicationRef) {
        console.log("info modal");
        //console.log(this.rootRef);
        // this.rootRef = appRef.components[0].injector.get(ElementRef);
      }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/popup-modals/info-modal/info-modal.component.ts